import botAvatar from "../photos/botAvatar.png";
import bingSearchIcon from "../photos/bingSearchIcon.svg";
import ubonaIcon from "../photos/ubonaIcon.png";
import avaamo from "../photos/avaamo.png";

const chatScreenAssetsManager = {
  botAvatar,
  bingSearchIcon,
  ubonaIcon,
  avaamo
};

export default chatScreenAssetsManager;
